import axiosInstance from '@/services/axiosInstance'

export async function getProductos () {
  try {
    const res = await axiosInstance({
      url: process.env.VUE_APP_URL_API_BASE + '/sincData/getProductos',
      method: 'POST',
      headers: {
        Authorization: 'Basic ' + process.env.VUE_APP_BASIC_AUTHORIZATION_API
      }
    })

    // si quieres mantener el log, puedes quitarlo o usar un logger
    // console.log(res.data)
    console.log(res.data)
    return res.data
  } catch (error) {
    console.error('Error al obtener productos:', error)
    throw error
  }
}
